module.exports = __webpack_public_path__ + "images/newerp_webicon.1788921444950.png";